import I18n from 'lib/i18n/i18n';
import { rootUrl } from '../helpers/ApplicationHelper'

const FooterData = () =>{

  const {tabs, copyright,logos:logosString } = I18n.getString('footer');

  const tabsLinks = [
    [
      {url: '/about'},
      {url: '/about/how-it-works'},
      {url: '/about/reviews'},
      {url: '/about/contact'},
      {url: '/refer_a_friend'},
      {url: '/about/faqs'},
      {url: '/about/what-we-accept'},
      {url: '/about/worthy-press'},
      {url: '/about/scholarship'},
    ],
    [
      {url: '/about/selling-with-trust'},
      {url: '/about/certifications-licenses'},
      {url: '/about/how-it-works/our-experts-and-labs'},
      {url: '/about/terms-and-conditions'},
      {url: '/about/privacy-policy'},
    ],
    [
      {url: '/sell-jewelry'},
      {url: '/sell-jewelry/engagement-ring'},
      {url: '/sell-jewelry/wedding-ring'},
      {url: '/sell-diamonds'},
      {url: '/sell-watches'},
      {url: '/blog/'},
      {url: '/promotions'},
      {url: '/famous-diamonds'},
      {url: '/sell-jewelry/local/'},
      {url: '/about/how-it-works/worthy-buyer-network'},
    ],
    [
      {url: '/jewelers'},
      {url: '/buyers/registration'},
      {url: '/buyers/sign_in'},
    ],
  ];
  const footerTabs = tabs.map((tab, tabIdx) => {
    tab.items = tab.items.map((link,linkIdx) => {
      return {
        name:link,
        link: tabsLinks[tabIdx][linkIdx].url,
        idx:linkIdx
      };
    });

    return tab;
  });

  const rowsLinks =  [
    [
      {link: rootUrl('/about/certifications-licenses')},
      {link: 'http://www.bbb.org/new-york-city/business-reviews/online-retailer/worthy-com-in-new-york-ny-149680',},
      {link: 'http://www.brinks.com/'}],
    [
      {link: 'http://www.gia.edu/gia-about-mission-governance'},
      {link: 'https://www.paypal.com/us/webapps/mpp/home'},
      {link: 'http://www.lloyds.com'},
    ]
  ];

  const logos = rowsLinks.map((row, idxLink) => {
    return row.map(({link},idxLogo) => {
      return {
        link,
        name:logosString[idxLink][idxLogo].name
      }
    })
  });

  return {footerTabs, copyright, logos}
};

export default FooterData();